<h2 class="header">
  {{ 'components.gamePlayEdit.titre' | transloco }} #{{ gamePlayNumber }}
</h2>

@if (editedGamePlay && gamePlayForm) {
  <form class="edit-grid" [formGroup]="gamePlayForm">
    <div class="main">
      <mat-card>
        <mat-card-title>{{ 'scoreBoard.quarter' | transloco }} / {{ 'components.gamePlayEdit.down' | transloco }}</mat-card-title>
        <div class="grid">
          <mat-form-field>
            <mat-label>{{ 'components.gamePlayEdit.odk' | transloco }}</mat-label>
            <mat-select formControlName="odk" data-testid="odk">
              @for (key of odkKeys; track key) {
                <mat-option [value]="odkEnum[key]">{{ key }}</mat-option>
              }
            </mat-select>
            <mat-hint>{{ 'components.gamePlayEdit.odkHint' | transloco }}</mat-hint>
            @if (gamePlayForm.controls['odk'].errors?.['required']) {
              <mat-error>{{ 'components.gamePlayEdit.odkEstObligatoire' | transloco }}</mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'components.gamePlayEdit.qtr' | transloco }}</mat-label>
            <mat-select formControlName="qtr" data-testid="qtr">
              @for (qtr of qtrEnum; track qtr) {
                <mat-option [value]="qtr">{{ qtr }}</mat-option>
              }
            </mat-select>
            @if (gamePlayForm.controls['qtr'].errors?.['required']) {
              <mat-error>{{ 'components.gamePlayEdit.qtrEstObligatoire' | transloco }}</mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'components.gamePlayEdit.down' | transloco }}</mat-label>
            <mat-select formControlName="down" data-testid="down">
              <mat-option [value]="1">1</mat-option>
              <mat-option [value]="2">2</mat-option>
              <mat-option [value]="3">3</mat-option>
              @if (getNumberOfDowns() === 4) {
                <mat-option [value]="4">4</mat-option>
              }
            </mat-select>
            <mat-hint>{{ 'components.gamePlayEdit.downHint' | transloco }}</mat-hint>
            @if (gamePlayForm.controls['down'].errors?.['required']) {
              <mat-error>{{ 'components.gamePlayEdit.downEstObligatoire' | transloco }}</mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'components.gamePlayEdit.distance' | transloco }}</mat-label>
            <input matInput type="number" formControlName="distance" data-testid="distance">
            <mat-hint>{{ 'components.gamePlayEdit.distanceHint' | transloco }}</mat-hint>
            @if (gamePlayForm.controls['distance'].errors?.['required']) {
              <mat-error>{{ 'components.gamePlayEdit.distanceEstObligatoire' | transloco }}</mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'components.gamePlayEdit.yardLine' | transloco }}</mat-label>
            <input matInput type="text" formControlName="yardLine" data-testid="yardLine">
            <mat-hint>{{ 'components.gamePlayEdit.yardLineHint' | transloco }}</mat-hint>
            @if (gamePlayForm.controls['yardLine'].errors?.['required']) {
              <mat-error>{{ 'components.gamePlayEdit.yardLineEstObligatoire' | transloco }}</mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'components.gamePlayEdit.hash' | transloco }}</mat-label>
            <mat-select formControlName="hash" data-testid="hash">
              @for (key of hashKeys; track key) {
                <mat-option [value]="hashEnum[key]">{{ key }}</mat-option>
              }
            </mat-select>
            <mat-hint>{{ 'components.gamePlayEdit.hashHint' | transloco }}</mat-hint>
            @if (gamePlayForm.controls['hash'].errors?.['required']) {
              <mat-error>{{ 'components.gamePlayEdit.hashEstObligatoire' | transloco }}</mat-error>
            }
          </mat-form-field>
        </div>
      </mat-card>

      <mat-card>
        <mat-card-title>{{ 'components.gamePlayEdit.playType' | transloco }}</mat-card-title>
        <div class="grid">
          <mat-form-field>
            <mat-label>{{ 'components.gamePlayEdit.playType' | transloco }}</mat-label>
            <mat-select formControlName="playType" data-testid="playType">
              @for (option of (playTypeEnum | filterOptions:gamePlayForm.value:'playType'); track option) {
                <mat-option [value]="option">{{ option }}</mat-option>
              }
            </mat-select>
            <mat-hint>{{ 'components.gamePlayEdit.playTypeHint' | transloco }}</mat-hint>
            @if (gamePlayForm.controls['playType'].errors?.['required']) {
              <mat-error>{{ 'components.gamePlayEdit.playTypeEstObligatoire' | transloco }}</mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'components.gamePlayEdit.result' | transloco }}</mat-label>
            <mat-select formControlName="result" data-testid="result">
              @for (option of (playResultEnum | filterOptions:gamePlayForm.value:'playResult'); track option) {
                <mat-option [value]="option">{{ option }}</mat-option>
              }
            </mat-select>
            <mat-hint>{{ 'components.gamePlayEdit.resultHint' | transloco }}</mat-hint>
            @if (gamePlayForm.controls['result'].errors?.['required']) {
              <mat-error>{{ 'components.gamePlayEdit.resultEstObligatoire' | transloco }}</mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'components.gamePlayEdit.gainLoss' | transloco }}</mat-label>
            <input matInput type="number" formControlName="gnLs" data-testid="gnLs">
            <mat-hint>{{ 'components.gamePlayEdit.gainLossHint' | transloco }}</mat-hint>
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'components.gamePlayEdit.kickYards' | transloco }}</mat-label>
            <input matInput type="number" formControlName="kickYards" data-testid="kickYards">
            <mat-hint>{{ 'components.gamePlayEdit.kickYardsHint' | transloco }}</mat-hint>
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'components.gamePlayEdit.returnYards' | transloco }}</mat-label>
            <input matInput type="number" formControlName="returnYards" data-testid="returnYards">
            <mat-hint>{{ 'components.gamePlayEdit.returnYardsHint' | transloco }}</mat-hint>
          </mat-form-field>
        </div>
      </mat-card>

      <mat-card>
        <mat-card-title>{{ 'components.gamePlayEdit.penalty' | transloco }}</mat-card-title>
        <div class="grid">
          <mat-form-field>
            <mat-label>{{ 'components.gamePlayEdit.penalty' | transloco }}</mat-label>
            <mat-select formControlName="penTeam" data-testid="penTeam">
              <mat-option [value]="null">—</mat-option>
              @for (key of penTeamKeys; track key) {
                <mat-option [value]="penTeamEnum[key]">{{ key }}</mat-option>
              }
            </mat-select>
            <mat-hint>{{ 'components.gamePlayEdit.penaltyHint' | transloco }}</mat-hint>
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'components.gamePlayEdit.penYards' | transloco }}</mat-label>
            <input matInput type="number" formControlName="penYards" data-testid="penYards">
            <mat-hint>{{ 'components.gamePlayEdit.penYardsHint' | transloco }}</mat-hint>
          </mat-form-field>
        </div>
      </mat-card>

      <mat-card>
        <mat-card-title>{{ 'components.gamePlayEdit.home' | transloco }} / {{ 'components.gamePlayEdit.away' | transloco }}</mat-card-title>
        <div class="players-grid">
          <div class="players-header">
            <span></span>
            <span class="home">{{ 'components.gamePlayEdit.home' | transloco }}</span>
            <span class="away">{{ 'components.gamePlayEdit.away' | transloco }}</span>
          </div>

          @for (role of playerRoles; track role.key) {
            @if (isRoleVisible(role)) {
            <div class="player-row">
              <span>{{ ('components.gamePlayEdit.' + role.i18nKey) | transloco }}</span>
              <div class="player-input">
                <input matInput type="number" min="0" max="99" [formControlName]="role.key" [attr.data-testid]="role.key">
                <button type="button" mat-icon-button [attr.data-testid]="role.key + 'Picker'"
                  (click)="openPlayerPicker(role.key, 'home')">
                  <mat-icon>more_horiz</mat-icon>
                </button>
              </div>
              <div class="player-input">
                <input matInput type="number" min="0" max="99" [formControlName]="role.oppKey" [attr.data-testid]="role.oppKey">
                <button type="button" mat-icon-button [attr.data-testid]="role.oppKey + 'Picker'"
                  (click)="openPlayerPicker(role.oppKey, 'away')">
                  <mat-icon>more_horiz</mat-icon>
                </button>
              </div>
            </div>
            }
          }
        </div>
      </mat-card>

      <div class="actions">
        <button type="button" mat-raised-button color="primary" data-testid="saveGamePlayEdit" (click)="save()">
          {{ 'components.gamePlayEdit.save' | transloco }}
        </button>
        <button type="button" mat-stroked-button data-testid="cancelGamePlayEdit" (click)="cancel()">
          {{ 'app.cancel' | transloco }}
        </button>
      </div>
    </div>
  </form>
}
